import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=5a677a5e&scoped=true"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=5a677a5e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a677a5e",
  null
  
)

export default component.exports